import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-emerald-800 text-white py-4 text-center">
      <p>&copy; 2024 Frend AI. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
